import React from 'react';

import { Root, Row, Name, DetailGroup, Detail, Accent, DEFAULT_EYEBROW_COLOR, DEAL_EYEBROW_COLOR } from './Eyebrow.styles';

export type EyebrowProps = {
  text: string;
  /** Muted terms detail beside the label — e.g. an affiliate's deal terms
   * ("$35 / FTD"). Its presence switches the eyebrow to its two-tone layout. */
  detail?: string;
  /** Emphasised (magenta) tail of the detail — a hybrid deal's fixed cost
   * ("$10,000 fixed"). Rendered immediately after `detail`. */
  detailAccent?: string;
  placeholders?: Record<string, string | number>;
  /** Overline colour. Defaults to the amber tone — or the tenant orange in the
   * two-tone (deal) layout. The channel campaign cards pass the tenant orange. */
  color?: string;
  className?: string;
};

/** Small overline label — campaign period, deal type, etc. With `detail` (and an
 *  optional `detailAccent`) it renders two-tone: orange type name + muted detail. */
export const Eyebrow = ({ text, detail, detailAccent, placeholders, color, className }: EyebrowProps): React.ReactElement => {
  const isDeal = detail !== undefined || detailAccent !== undefined;
  const nameColor = color ?? (isDeal ? DEAL_EYEBROW_COLOR : DEFAULT_EYEBROW_COLOR);

  if (!isDeal) {
    return <Root $color={nameColor} text={text} placeholders={placeholders} tag="span" className={className} />;
  }

  return (
    <Row className={className}>
      <Name $color={nameColor} text={text} placeholders={placeholders} tag="span" />
      <DetailGroup>
        {detail !== undefined ? <Detail text={detail} tag="span" /> : null}
        {detailAccent !== undefined ? <Accent text={detailAccent} tag="span" /> : null}
      </DetailGroup>
    </Row>
  );
};

export default Eyebrow;
